import { useEffect, useState } from "react";

export type Theme = "dark" | "light";
const THEME_KEY = "theme";

// Apply theme immediately when module loads to avoid flash-of-wrong-theme
// before React renders.
const _initial = (localStorage.getItem(THEME_KEY) as Theme | null) ?? "dark";
document.documentElement.setAttribute("data-theme", _initial);

export function useTheme() {
  const [theme, setTheme] = useState<Theme>(_initial);

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
    localStorage.setItem(THEME_KEY, theme);
  }, [theme]);

  const toggle = () => setTheme((t) => (t === "dark" ? "light" : "dark"));

  return { theme, toggle };
}
